'use strict';
var carswip = carswip || {};
const quoteBoxes = document.querySelectorAll('.js-item-quotebox');
const brands = document.querySelectorAll('.js-item-brand');

carswip.brands = carswip.brands || function () {
	function init() {
        if(brands) {
            for (let i = 0; i < brands.length; i++) {
                const currentBrand = brands[i];
                if(i == 0) {
                    currentBrand.classList.add('item-brand--active');
                }
                currentBrand.addEventListener('click', function(e) {
                    let clickedBrand = e.currentTarget;
                    let brandId = clickedBrand.getAttribute('data-id');
                    let quoteBoxWithId = document.querySelector('.js-item-quotebox[data-id="' + brandId + '"]');
                    let visibleQuotebox = document.querySelector('.js-item-quotebox.item-quotebox--visible');
                    let activeBrand = document.querySelector('.js-item-brand.item-brand--active');

                    if(quoteBoxWithId) {
                        activeBrand.classList.remove('item-brand--active');
                        clickedBrand.classList.add('item-brand--active');
                        visibleQuotebox.classList.remove('item-quotebox--visible');
                        quoteBoxWithId.classList.add('item-quotebox--visible');
                    }
                });
            }
        }

        if(quoteBoxes) {
            for (let i = 0; i < quoteBoxes.length; i++) {
                const currentBox = quoteBoxes[i];
                if(i == 0) {
                    currentBox.classList.add('item-quotebox--visible');
                }
            }
        }
	}

	return {
		init : init
	};
}();